module.exports = __webpack_public_path__ + "img/socio14.b191ea08.png";